import React, { memo } from 'react';
import { Footer } from '../components/Footer';
import { Feather, Heart, BookOpen, Brain, Handshake, Globe, Target, Building, Ear } from 'lucide-react';
export const AboutUs = () => {
  return <div className="flex flex-col min-h-screen" data-id="element-492">
      <main className="relative flex-grow overflow-hidden" data-id="element-493">
        <div className="absolute inset-0 bg-grid-gray-900/[0.02] -z-10" data-id="element-494" />
        {/* XL Cyan gradient blob */}
        <div className="absolute -top-[200px] left-1/3 w-[1200px] h-[1200px] bg-gradient-to-br from-cyan-400/20 via-cyan-300/15 to-primary-200/10 rounded-[45%_55%_50%_50%] blur-3xl -z-10" data-id="element-495" />
        {/* Hero section */}
        <section className="w-full pt-16 pb-10 md:pt-20 md:pb-14 relative overflow-hidden" data-id="element-496">
          <div className="absolute top-0 right-1/4 w-[900px] h-[900px] bg-gradient-to-br from-cyan-700/10 via-teal-500/20 to-blue-400/10 rounded-[60%_40%_55%_45%] blur-3xl -z-10" data-id="element-497" />
          <div className="container mx-auto px-4 sm:px-6" data-id="element-498">
            <div className="max-w-4xl mx-auto" data-id="element-499">
              <div className="flex flex-col md:flex-row items-center gap-4 mb-6 justify-center p-0" data-id="element-500">
                <h1 className="text-4xl md:text-4xl font-serif font-normal text-cyan-900 text-center md:text-left pt-6" data-id="element-501">
                  About the Nisa Team
                </h1>
                <div className="md:w-auto flex justify-center" data-id="element-502">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iT3rTW2gA8gm9VBU9nHsNk/Nisa_-_Plant_Arc_Growth.png" alt="Plant growth illustration" className="w-full max-w-[150px]" data-id="element-503" />
                </div>
              </div>
              <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-504">
                <p className="text-xl font-medium mb-6 text-center" data-id="element-505">
                  We believe great instruction is a right, not a privilege.
                </p>
                <p className="mb-6 text-lg pb-5 mx-auto" style={{
                width: 'calc(80% + 40px)'
              }} data-id="element-506">
                  We're building tools that support the people who make that
                  possible every day: instructional coaches and the teachers
                  they partner with. Whether it's helping a coach prepare a
                  planning session, supporting a teacher as they refine their
                  lesson, or capturing insights from classroom practice, Nisa is
                  designed to show up quietly and helpfully—just when it's
                  needed.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Mission image moved here, above Why Nisa section */}
        <div className="mb-10 max-w-3xl mx-auto" data-id="element-507">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a6oMit83Uh87AeL1tTsyKz/image.png" alt="Our Mission: Reduce the mental overhead of coaching and teaching, so educators can focus on what matters most: great instruction and thriving classrooms." className="w-full rounded-lg shadow-sm" data-id="element-508" />
        </div>
        {/* Why Nisa section */}
        <section className="w-full py-section-mobile relative overflow-hidden bg-gradient-to-br from-white via-primary-50/30 to-blue-50/30" data-id="element-509">
          <div className="absolute bottom-0 left-1/4 w-[800px] h-[800px] bg-gradient-to-tr from-teal-400/20 via-cyan-400/10 to-sky-400/10 rounded-[40%_60%_45%_55%] blur-3xl -z-10" data-id="element-510" />
          <div className="container mx-auto px-4 sm:px-6" data-id="element-511">
            <div className="max-w-4xl mx-auto" data-id="element-512">
              <div className="flex items-center justify-center mb-8" data-id="element-513">
                <h2 className="text-2xl md:text-4xl font-serif font-normal text-gray-600" data-id="element-514">
                  Why "Nisa"?
                </h2>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-515">
                <p className="mb-6 text-gray-700" data-id="element-516">
                  The name "Nisa" is inspired by Nisaba, the ancient Sumerian
                  goddess of learning, writing, and memory. She was believed to
                  hold humanity's story—tracking its unfolding through careful
                  inscription. That same spirit lives in our work.
                </p>
                <p className="mb-6 text-gray-700" data-id="element-517">How Nisa helps educators:</p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-518">
                  <div className="bg-gradient-to-br from-sky-100 to-sky-200/90 rounded-lg p-4 border border-sky-300/60 hover:shadow-md transition-shadow" data-id="element-519">
                    <div className="flex flex-col items-center text-center" data-id="element-520">
                      <div className="bg-gradient-to-br from-sky-200 to-sky-300 rounded-full p-3 mb-3 flex-shrink-0" data-id="element-521">
                        <BookOpen className="w-5 h-5 text-sky-700" data-id="element-522" />
                      </div>
                      <span className="text-gray-800 font-medium" data-id="element-523">
                        Capture what matters
                      </span>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-indigo-100 to-blue-200/90 rounded-lg p-4 border border-indigo-300/60 hover:shadow-md transition-shadow" data-id="element-524">
                    <div className="flex flex-col items-center text-center" data-id="element-525">
                      <div className="bg-gradient-to-br from-indigo-200 to-blue-300 rounded-full p-3 mb-3 flex-shrink-0" data-id="element-526">
                        <Target className="w-5 h-5 text-indigo-700" data-id="element-527" />
                      </div>
                      <span className="text-gray-800 font-medium" data-id="element-528">
                        Plan with purpose
                      </span>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-purple-100 to-fuchsia-200/90 rounded-lg p-4 border border-purple-300/60 hover:shadow-md transition-shadow" data-id="element-529">
                    <div className="flex flex-col items-center text-center" data-id="element-530">
                      <div className="bg-gradient-to-br from-purple-200 to-fuchsia-300 rounded-full p-3 mb-3 flex-shrink-0" data-id="element-531">
                        <Building className="w-5 h-5 text-purple-700" data-id="element-532" />
                      </div>
                      <span className="text-gray-800 font-medium" data-id="element-533">
                        Build conditions for excellent, equitable teaching
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-gray-700" data-id="element-534">
                  Like Nisaba, we honor the knowledge that lives in classrooms.
                  We see educators not just as implementers of curriculum, but
                  as authors of progress. Nisa is here to support their wisdom,
                  not replace it.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Our Values section */}
        <section className="w-full py-section-mobile relative overflow-hidden" data-id="element-535">
          <div className="absolute top-1/3 right-0 w-[700px] h-[700px] bg-gradient-to-br from-sky-400/10 via-cyan-400/10 to-teal-400/20 rounded-[45%_55%_50%_50%] blur-3xl -z-10" data-id="element-536" />
          <div className="container mx-auto px-4 sm:px-6" data-id="element-537">
            <div className="max-w-4xl mx-auto" data-id="element-538">
              <div className="flex items-center justify-center mb-8" data-id="element-539">
                <h2 className="text-2xl md:text-4xl font-serif font-normal text-gray-600" data-id="element-540">
                  Our Values
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-541">
                <div className="bg-cyan-100/80 rounded-lg p-6 border border-cyan-200/60 hover:shadow-sm transition-shadow" data-id="element-542">
                  <div className="flex items-start" data-id="element-543">
                    <div className="bg-cyan-300 rounded-md p-1 mr-4 flex-shrink-0" data-id="element-544">
                      <Ear className="w-7 h-7 text-white" data-id="element-545" />
                    </div>
                    <div data-id="element-546">
                      <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-547">
                        Listen deeply
                      </h3>
                      <p className="text-gray-700" data-id="element-548">
                        We center the lived experiences of educators. Their
                        voice shapes everything we build.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-teal-100/80 rounded-lg p-6 border border-teal-200/60 hover:shadow-sm transition-shadow" data-id="element-549">
                  <div className="flex items-start" data-id="element-550">
                    <div className="bg-teal-300 rounded-md p-1 mr-4 flex-shrink-0" data-id="element-551">
                      <Brain className="w-7 h-7 text-white" data-id="element-552" />
                    </div>
                    <div data-id="element-553">
                      <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-554">
                        Reduce cognitive load
                      </h3>
                      <p className="text-gray-700" data-id="element-555">
                        Teaching and coaching are complex. We strive to bring
                        clarity, not clutter.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-sky-100/80 rounded-lg p-6 border border-sky-200/60 hover:shadow-sm transition-shadow" data-id="element-556">
                  <div className="flex items-start" data-id="element-557">
                    <div className="bg-sky-300 rounded-md p-1 mr-4 flex-shrink-0" data-id="element-558">
                      <Handshake className="w-7 h-7 text-white" data-id="element-559" />
                    </div>
                    <div data-id="element-560">
                      <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-561">
                        Partner with purpose
                      </h3>
                      <p className="text-gray-700" data-id="element-562">
                        We don't chase trends. We build tools that integrate
                        into real workflows and support lasting change.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-primary-100/80 rounded-lg p-6 border border-primary-200/60 hover:shadow-sm transition-shadow" data-id="element-563">
                  <div className="flex items-start" data-id="element-564">
                    <div className="bg-primary-300 rounded-md p-1 mr-4 flex-shrink-0" data-id="element-565">
                      <Globe className="w-7 h-7 text-white" data-id="element-566" />
                    </div>
                    <div data-id="element-567">
                      <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-568">
                        Equity as a design principle
                      </h3>
                      <p className="text-gray-700" data-id="element-569">
                        We believe every student deserves access to excellent
                        instruction—and every educator deserves tools that
                        support that mission.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Who We Are section */}
        <section className="w-full py-section-mobile pb-16 relative overflow-hidden bg-gradient-to-br from-white via-primary-50/30 to-blue-50/30" data-id="element-570">
          <div className="absolute bottom-1/3 left-0 w-[600px] h-[600px] bg-gradient-to-tr from-teal-400/20 via-cyan-300/10 to-emerald-400/10 rounded-[55%_45%_40%_60%] blur-3xl -z-10" data-id="element-571" />
          <div className="container mx-auto px-4 sm:px-6" data-id="element-572">
            <div className="max-w-4xl mx-auto" data-id="element-573">
              <div className="flex items-center justify-center mb-8" data-id="element-574">
                <h2 className="text-2xl md:text-4xl font-serif font-normal text-gray-600" data-id="element-575">
                  Who We Are
                </h2>
              </div>
              <div className="bg-gradient-to-r from-cyan-100/25 to-teal-200/25 backdrop-blur-sm rounded-xl p-5 shadow-sm border border-gray-100 flex flex-col md:flex-row items-center" data-id="element-576">
                <div className="md:w-auto flex-shrink-0" data-id="element-577">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pfwRrB6KfuFaW7KfrpbYwz/Nisa_Duo_Orange.png" alt="Nisa team illustration" className="w-full max-w-[224px]" data-id="element-578" />
                </div>
                <div className="md:flex-1" data-id="element-579">
                  <p className="text-gray-700 text-lg leading-relaxed" data-id="element-580">
                    We're a team of educators and technologists committed to
                    reimagining the tools educators use every day. We've taught
                    in classrooms, led school teams, coached teachers, and built
                    edtech products. Now we're building something better for the
                    people we've worked alongside and the communities they
                    serve.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-581" />
    </div>;
};